import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ctaButton: 'Finish',
    infoText:
      'Your beneficiaries will receive them within 2 to 3 working days.',
    title: 'Your bulk transfer has been successfully initiated',
    toastMessage:
      'Your transfers have been successfully initiated. They will appear here in a few minutes.',
    totalAmount: 'Total amount:',
  },
  fr: {
    ctaButton: 'Terminer',
    infoText: 'Vos bénéficiaires recevront les fonds sous 2 à 3 jours ouvrés.',
    title: 'Votre virement groupé a bien été enregistré',
    toastMessage:
      'Vos virements ont bien été enregistrés. Ils apparaîtront d’ici quelques minutes.',
    totalAmount: 'Montant total\xA0:',
  },
} as const);

export default locales;
